/** Fallback for @dls/react-theme */

import { smartQareExtendedPalette, smartQarePalette } from './colors';

/** Returns a plain object that MUI createTheme can spread without errors. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
export const makeTheme = (_config: any) => (): Record<string, unknown> => ({
  palette: {
    primary: {
      main: smartQarePalette.royalPurple,
      dark: smartQarePalette.spacePurple,
      light: smartQarePalette.lavender,
      contrastText: smartQarePalette.white,
    },
    secondary: {
      main: smartQarePalette.ochreOrange,
      contrastText: smartQarePalette.spacePurple,
    },
    background: {
      default: smartQareExtendedPalette.pageBackground,
      paper: smartQarePalette.white,
    },
    text: {
      primary: smartQarePalette.spacePurple,
      secondary: smartQareExtendedPalette.textSecondary,
    },
  },
});

/** Converts px to em relative to a base font size (default 16px). */
export const em = (value: number, base = 16): string => `${value / base}em`;
